export default __webpack_public_path__ + "static/media/pfp 5-min.c60cf5ad.png";